import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/** Per-outcome session counts for one merchant over the range. */
export const hsaFunnelTotals = z.object({
  /** Partner-handoff sessions started in range (the redirect landed). */
  sessions: z.number(),
  /** Sessions that rendered at least one questionnaire step. */
  started: z.number(),
  /** Partner accepted the survey: the handoff is complete. */
  submitted: z.number(),
  /** Ended on a KNOCKOUT node (ineligible by their own answers). */
  knockedOut: z.number(),
  /** Partner refused the completed survey at submit. */
  partnerRejected: z.number(),
  /** Rendered a step, never finished, and went quiet. */
  droppedOff: z.number(),
  /** Redirect landed but no step ever rendered. */
  bounced: z.number(),
  /** Recent sessions with no terminal outcome yet. */
  inProgress: z.number(),
  /** submitted / started; null when nothing started. */
  completionRate: z.number().nullable(),
});

/**
 * Cross-merchant LMN questionnaire funnel: one totals block per HSA-enabled
 * merchant for a session started-at date range. Event-sourced from
 * `hsa_session_event` (CockroachDB); exact, not warehouse-lagged. The funnel
 * ends at the handoff to the partner: LMN review and payment happen on the
 * partner's side and are not included.
 *
 * Skew rule: fields added later must be `.nullish()`.
 */
export const getHsaFunnelAnalytics = {
  name: "getHsaFunnelAnalytics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    /** Every HSA-enabled merchant, busiest first; zeros when quiet. */
    perTeam: z.array(
      z.object({
        teamId: z.string(),
        name: z.string(),
        storeUrl: z.string(),
        totals: hsaFunnelTotals,
      }),
    ),
    /** Earliest date with funnel data; the picker clamps to it. */
    dataStartDate: isoDate,
  }),
};
